import util from '@/util'
import constants from '@/util/constants'
import { infraMixin } from '@/modules/infra/mixins'
import infra from '@/util/infra'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import { encerrarChat } from '@/components/global/SuporteOnline'

export default {
  name: 'Login',
  components: {
    'b-spinner': BSpinner,
    'b-toast': BToast,
    PainelAcesso
  },
  mixins: [infraMixin],
  computed: {
  },
  data: () => ({
    dadosFormulario: {
      email: '',
      senha: ''
    },
    flags: {
      efetuandoLogin: false
    },
    mostrarSenha: false,
    erroValidacaoCampos: {},
    mensagemAlerta: ''
  }),

  async mounted () {
    await encerrarChat(this)
    if (!infra.estaEmModoDev()) {
      this.redirecionarSeNaoEstiverNaRotaDefault(constants.nomeRotaLoginLite)
    }
  },

  methods: {
    ...mapActions('auth', ['ActionSignOut']),

    alternarSenha () {
      this.mostrarSenha = !this.mostrarSenha
    },
    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.autenticar()
      }
    },

    async autenticar () {
      if (this.flags.efetuandoLogin !== true) {
        this.callbackAposLoginSucesso = null
        this.mensagemAlerta = ''
        const validacaoSucesso = this.validarDadosFormulario()
        if (validacaoSucesso) {
          await this.efetuarLogin()
        }
      }
    },

    validarDadosFormulario () {
      this.erroValidacaoCampos = {}
      const dados = this.dadosFormulario
      let validacaoSucesso = true

      for (let indice in dados) {
        let campo = dados[indice].trim()
        if (util.valorVazio(campo)) {
          this.erroValidacaoCampos[indice] = 'Este campo é obrigatório'
          validacaoSucesso = false
        }
      }

      return validacaoSucesso
    },

    async efetuarLogin () {
      this.flags.efetuandoLogin = true
      const dadosLogin = await this.enviarRequisicaoLogin()
      const loginSucesso = this.validarLogin(dadosLogin)
      if (loginSucesso) {
        this.ActionSignOut()
        window.open(dadosLogin.url_login, '_self')
        this.flags.efetuandoLogin = false
      } else {
        this.mensagemAlerta = dadosLogin.message
        this.flags.efetuandoLogin = false
      }
    },

    async enviarRequisicaoLogin () {
      let dadosRespostaRequisicao = null
      try {
        const resposta = await this.axios.post('/manager/login', {
          'email': this.dadosFormulario.email,
          'password': this.dadosFormulario.senha
        })
        dadosRespostaRequisicao = resposta.data
      } catch (e) {
        dadosRespostaRequisicao = e.response.data
        this.mensagemAlerta = mensagens.falhaComunicacaoServidor
      }
      return dadosRespostaRequisicao
    },

    validarLogin (dadosLogin) {
      if (util.valorEhNulo(dadosLogin)) {
        return false
      }

      const loginSucesso = dadosLogin.success
      if (!loginSucesso) {
        this.mensagemAlerta = dadosLogin.message
      }

      return loginSucesso
    }
  }
}
